"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationCancellationDto = instanceOfOrientationCancellationDto;
exports.OrientationCancellationDtoFromJSON = OrientationCancellationDtoFromJSON;
exports.OrientationCancellationDtoFromJSONTyped = OrientationCancellationDtoFromJSONTyped;
exports.OrientationCancellationDtoToJSON = OrientationCancellationDtoToJSON;
exports.OrientationCancellationDtoToJSONTyped = OrientationCancellationDtoToJSONTyped;
const ShiftCancellationReason_1 = require("./ShiftCancellationReason");
/**
 * Check if a given object implements the OrientationCancellationDto interface.
 */
function instanceOfOrientationCancellationDto(value) {
    return true;
}
function OrientationCancellationDtoFromJSON(json) {
    return OrientationCancellationDtoFromJSONTyped(json, false);
}
function OrientationCancellationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': json['reason'] == null ? undefined : (0, ShiftCancellationReason_1.ShiftCancellationReasonFromJSON)(json['reason']),
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function OrientationCancellationDtoToJSON(json) {
    return OrientationCancellationDtoToJSONTyped(json, false);
}
function OrientationCancellationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': (0, ShiftCancellationReason_1.ShiftCancellationReasonToJSON)(value['reason']),
        'comment': value['comment'],
    };
}
//# sourceMappingURL=OrientationCancellationDto.js.map